import axios from "axios"
import useSWR from "swr"

const fetcher = async (url) => {
  return await axios.get(url).then((res) => res.data.data)
}

const useStockAdjustmentDetailRepositories = (id, enabled = true) => {
  const shouldFetch = Boolean(id) && enabled

  const { data, error, mutate, isValidating } = useSWR(
    shouldFetch
      ? `${process.env.REACT_APP_INVENTORY_API_URL}/stock-adjustments/${id}`
      : null,
    fetcher
  )

  return {
    data,
    isLoading: shouldFetch && !error && !data,
    error,
    isValidating,
    mutate,
  }
}

export default useStockAdjustmentDetailRepositories
